import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

export default class extends Controller {
  static targets = ["base", "quotes", "from", "to", "group", "canvas"]
  static values = { ratesUrl: String }

  connect() {
    this.chart = echarts.init(this.canvasTarget)
    this.resizeHandler = () => this.chart.resize()
    window.addEventListener("resize", this.resizeHandler)
    this.refresh()
  }

  refresh() {
    const quotes = Array.from(this.quotesTarget.selectedOptions).map((option) => option.value)

    const params = new URLSearchParams({
      base: this.baseTarget.value,
      quotes: quotes.join(","),
      from: this.fromTarget.value,
      to: this.toTarget.value,
      group: this.groupTarget.value
    })

    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    fetch(`${this.ratesUrlValue}?${params}`, { signal: this.abortController.signal })
      .then((response) => response.json())
      .then((data) => this.render(data))
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error(error)
        }
      })
  }

  render(data) {
    this.chart.setOption({
      xAxis: {
        type: "category",
        data: data.labels
      },
      yAxis: {
        type: "value"
      },
      tooltip: {
        trigger: "axis"
      },
      legend: {
        top: 0,
        type: "scroll"
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        top: 40,
        left: 8,
        right: 8,
        containLabel: true
      },
      dataZoom: [
        { type: "inside", start: 0, end: 100 },
        { type: "slider", start: 0, end: 100 }
      ],
      series: data.series
    }, { replaceMerge: ["series"] })
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)

    if (this.abortController) {
      this.abortController.abort()
    }

    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }
}
